module.exports = __webpack_public_path__ + "img/stoerer_both.94cb5255.png";